import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class UserData {
  abstract deleteUser(mem_id: number): Observable<ApiResponse>;
  abstract saveUser(userData: any): Observable<ApiResponse>;
  abstract getUsersByPagination(page: number, pageSize: number): Observable<ApiResponse>;
  abstract updateUser(userData: any): Observable<ApiResponse>;
}
